import { render } from "./CardStatsEntries.vue?vue&type=template&id=2242ff3c"
import script from "./CardStatsEntries.vue?vue&type=script&lang=js"
export * from "./CardStatsEntries.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__